import Splide from "@splidejs/splide";

export default () => ({
  init() {
    this.initSlider();
  },

  initSlider() {
    const inBackend = document.body.classList.contains("neos-backend");

    if (inBackend) return;

    const horizontal = new Splide(".horizontal-slider", {
      type: "fade",
      perPage: 1,
      perMove: 1,
      drag: false,
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const vertical = new Splide(".vertical-slider", {
      perPage: 3,
      // type: "loop",
      perMove: 1,
      direction: "ttb",
      focus: 1,
      pagination: false,
      // rewind: false,
      height: "100%",
      lazyLoad: "nearby",
      isNavigation: true,
      gap: 20,
    });

    horizontal.sync(vertical);
    horizontal.mount();
    vertical.mount();
  },
});
